angular.module('eatself')
.directive('popoverToggler', function($timeout){
	// Runs during compile
	return {
		// name: '',
		// priority: 1,
		// terminal: true,
		scope: {
			popoverIsOpen: '=',
		}, // {} = isolate, true = child, false/undefined = no change
		controller: function($scope, $element, $attrs, $transclude) {
		},
		// require: 'ngModel', // Array = multiple requires, ? = optional, ^ = check parent elements
		// restrict: 'A', // E = Element, A = Attribute, C = Class, M = Comment
		// template: '',
		// templateUrl: '',
		// replace: true,
		// transclude: true,
		// compile: function(tElement, tAttrs, function transclude(function(scope, cloneLinkingFn){ return function linking(scope, elm, attrs){}})),
		link: function($scope, iElm, iAttrs, controller) {
			$scope.$watch('popoverIsOpen',togglePopover);
			$scope.$on('$destroy',stopListening);

			function togglePopover(isOpen) {
				if (isOpen) {
					popoverOpened();
				} else {
					stopListening();
				}
			}

			function popoverOpened() {
				listenToClicks();
				iElm.next().css('padding-bottom', 0);
				$timeout(() => iElm.next().find('input:first').focus(), 50);
			}

			function listenToClicks() {
				// this.cb = this.clickCb.bind(this);
				$timeout(() => $(document).on('click', clickCb));
			}
			function stopListening() {
				$(document).off('click', null, clickCb);
			}
			function clickCb(ev) {
				if (!$.contains(iElm.next()[0], ev.target)) {
					closePopover();
					$scope.$evalAsync();
				}
			}
			function closePopover() {
				$scope.popoverIsOpen = false;
				stopListening();
			}
		}
	};
});
